export default __webpack_public_path__ + "static/media/book-gray.ec3669cf.svg";